<button
  [type]="type"
  (click)="submit()"
  [ngClass]="classesName"
  class="btn-edge-cut text-white relative px-4 py-2 cursor-pointer font-medium"
  [disabled]="disabled"
>
 <span class="relative z-10">
  @if (disabled) {
    <div class="flex flex-col items-center justify-center space-y-2">      
      <div class="flex space-x-2 text-white">
        <span class="text-white">
         {{ label }} 
        </span>
        <span
          class="mt-3 w-2 h-2 rounded-full bg-white animate-bounce [animation-delay:-0.3s]"
        ></span>
        <span
          class="mt-3 w-2 h-2 rounded-full bg-white animate-bounce [animation-delay:-0.15s]"
        ></span>
        <span class="mt-3 w-2 h-2 rounded-full bg-dc-green animate-bounce"></span>
      </div>
    </div>
  }@else {
    @if (iconClass) {
      <i class="{{ iconClass }} px-1"></i>
      }
      {{ label }}  
  }
  </span>
</button>
